import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
  useStore,
} from 'react-redux';

import { RootDispatch, RootState, RootStore } from '@store';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useTypedDispatch: () => RootDispatch = useDispatch;

export const useTypedStore: () => RootStore = useStore;
